import * as React from 'react';
import { Modal } from 'rcd-cpp-ui/ui/modal/Modal';
import { Primary, Buttons } from 'rcd-cpp-ui/ui/button';
import { Field } from '../../MetadataForm/metadataFormField';
import { getUpdater } from '../../MetadataForm/metadataForm';
import { useActions } from '../administrationActions';
import './administrationForm.scss';
import { RoleField } from '../RoleField/roleField';
import { useAlert } from '../../Alert/alert';
import { useLoader } from '../../Loader/loader';
import { useSelector } from '../../../utils/useSelector';

export const AdministrationForm = props => {
  const data = useSelector(s => s.administration?.data);
  const schema = useSelector(s => s.administration?.schema);
  const workspace = useSelector(s => s.planning?.workspaces);
  const { disabled } = props;
  const { closeForm, updateField, updateFields, ...actions } = useActions();
  const { isLoading, Loader, setMessage, Alert, save } = useAlert(
    useLoader(actions)
  );
  React.useEffect(() => {
    setMessage(null);
  }, [data]);

  const fields = schema?.props?.fields || [];

  const updater = getUpdater({ updateField, updateFields }, !!data?.id);
  React.useEffect(() => {
    updater.reset();
  }, []);

  if (!workspace || !data) return null;
  const isEdit = !!data?.id;
  const header = `${isEdit ? 'Edit' : 'Add'} ${
    schema?.props?.name || data?.labels?.join(':')
  }`;

  return (
    <Modal
      id="administrationFormModal"
      onClose={() => closeForm()}
      header={header}
      footer={
        <Buttons>
          {!isEdit && (
            <Primary
              label="Add Another"
              onClick={() => {
                save(true);
              }}
              disabled={isLoading}
            />
          )}
          <Primary
            label={isEdit ? 'Save' : 'Add'}
            onClick={() => {
              save();
            }}
            disabled={disabled || isLoading}
          />
        </Buttons>
      }
    >
      <Loader />
      <div className="metadata-form scrollable">
        <Alert />
        {fields.map(field => {
          const CustomField = CustomFields[field.key];
          let fieldDisabled = disabled;
          if (field.field == 'employee') {
            fieldDisabled = !!data?.id && data?.props?.employee?.length;
          }
          return (
            <Field
              key={field.field}
              field={field}
              data={data}
              schema={schema}
              disabled={fieldDisabled || isLoading}
              updater={updater}
            >
              {!!CustomField && <CustomField />}
            </Field>
          );
        })}
      </div>
    </Modal>
  );
};

const CustomFields = {
  'Permission.roles': RoleField
};
